<template>

    <m-edit1/>

    <m-loading-3 v-bind='{...{},...{}}' :style='""' class="" ></m-loading-3><m-update-site-message-1 v-bind='{...{},...{}}' :style='""' class="" ></m-update-site-message-1><m-div v-bind='{...{},...{}}' :style='"background: var(--primary);"' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="p-0 mx-auto m-0 container" >
                <template #default>   <m-nav-309 v-bind='{...{"sideMenuPosition":"store_nav","mainMenuPosition":"blog_nav","dashboardLink":"https:\/\/dash.arair.ir\/dashboard","AuthLink":{"name":"Login"},"image":null,"showPanels":false,"imageParentClass":"col-lg-6 d-none d-lg-block","defaultPanel":null},...{}}' :style='""' class="text-center" >
                <template #classic-login-p-1-bottom>   </template>
                
                <template #classic-login-p-1-top>   </template>
                
                <template #footer>   </template>
                
                <template #menu-4>   <m-a v-bind='{...{"href":"https:\/\/dash.arair.ir\/dashboard","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>حساب کاربری   </template>
                </m-a></template>
                
                <template #two-step-login-p-1-bottom>   </template>
                
                <template #two-step-login-p-1-top>   </template>
                </m-nav-309></template>
                </m-div></template>
                </m-div><m-nav-305 v-bind='{...{"shoppingCartToggleTo":null,"activeSms":false,"navDataToggle":"#nav-305-menu","menuPosition":"blog_footer","searchInput":"mSearchInput200"},...{}}' :style='""' class="" >
                <template #p-1>   </template>
                
                <template #p-2>   </template>
                
                <template #p-3>   </template>
                </m-nav-305><router-view name='site' v-bind='{...{},...{}}' :style='""' class='""' /><m-div v-bind='{...{},...{}}' :style='"\nbackground:var(--secondary) ;\nbackground-image: url(\"https:\/\/api.arair.ir\/storage\/asset\/bg.png\");\nbackground-repeat: no-repeat;\nbackground-size: cover;\n"' class="shadow container-fluid bg-primary" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row text-center py-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6 text-center" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/icons\/bEm0LkDHIZLbCR5OhzMutihxYLlXupFTHX0L8GOZ.png","alt":"amudco"},...{}}' :style='"width:200px "' class="img-fluid" ></m-img><m-h4 v-bind='{...{},...{}}' :style='""' class="my-3" >
                <template #default>کلینیک آرا   </template>
                </m-h4><m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کاشت مو ، پوست ، مو و زیبایی   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/www.instagram.com\/clinic_ara","target":"_self"},...{}}' :style='""' class="col-3" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.arair.ir\/storage\/icons\/instagram_240px.png","alt":"mix it web"},...{}}' :style='"height:50px;"' class="" ></m-img></template>
                </m-a><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-enamad-1 v-bind='{...{},...{}}' :style='""' class="" ></m-enamad-1></template>
                </m-div></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>آدرس   <m-p v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>دزفول - خیابان روستا بین حضرت رسول و بهشتی - درمانگاه امام علی طبقه دوم - کلینیک تخصصی پوست وموآرا   </template>
                </m-p></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-lg-3 col-sm-6" >
                <template #default>تماس با ما   <m-a v-bind='{...{"href":"tel:06142270636","target":"_self"},...{}}' :style='""' class="d-block text-dark my-2" >
                <template #default>06142270636   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-12" >
                <template #default>   <m-hr v-bind='{...{},...{}}' :style='""' class="" ></m-hr></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6 text-dark" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/mixitweb.com","target":"_self"},...{}}' :style='""' class="text-dark" >
                <template #default>ساخته شده با  ❤ توسط mixitweb   </template>
                </m-a></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="col-6" >
                <template #default>   <m-a v-bind='{...{"href":"https:\/\/arair.ir\/","target":"_self"},...{}}' :style='""' class="text-blue" >
                <template #default>تمام حقوق برای کلینیک آرا محفوظ است .   </template>
                </m-a></template>
                </m-div></template>
                </m-div></template>
                </m-div><m-a v-bind='{...{"href":"http:\/\/wa.me\/+989168431970","target":"_self"},...{}}' :style='"font-size:10px"' class="" >
                <template #default>   <m-button-903 v-bind='{...{},...{}}' :style='""' class="bg-success " >
                <template #default>   <m-icon v-bind='{...{"icon":"whatsapp"},...{}}' :style='""' class="h2" ></m-icon></template>
                </m-button-903></template>
                </m-a>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mLoading3 from '@moeinmdn/miw-alpha-components/src/package/Loading/Loading3'; import mUpdateSiteMessage1 from '@moeinmdn/miw-alpha-components/src/package/UpdateSiteMessage/UpdateSiteMessage1'; import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mNav309 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav309/Nav309'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mNav305 from '@moeinmdn/miw-alpha-components/src/package/Navs/Nav305/Nav305'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mP from '@moeinmdn/miw-alpha-components/src/package/Tags/P'; import mEnamad1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Enamad/Enamad1'; import mHr from '@moeinmdn/miw-alpha-components/src/package/Tags/Hr'; import mButton903 from '@moeinmdn/miw-alpha-components/src/package/Buttons/Button903'; import mIcon from '@moeinmdn/miw-alpha-components/src/package/Icons/Icon';

export default {
    name: 'HomeView',
    components: {mEdit1, mLoading3,mUpdateSiteMessage1,mDiv,mNav309,mA,mNav305,mImg,mH4,mP,mEnamad1,mHr,mButton903,mIcon },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
